import { HttpResponse } from '@angular/common/http';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LogService, Session, isManagement } from 'src/app/my-sedgwick';
import { TranslationRequest } from '../../../shared/models/translation/translation-request';
import { UserActionService } from '../../../shared';
import { UserActions } from '../../../shared/models/user';
import { ConfigurationService } from '../../services/configuration.service';
import { HelpfulLinkService } from '../../services/helpful-link.service';
import { UserRoleService } from '../../services/user-role.service';
import { UtilityService } from '../../services/utility.service';
import { TranslationService } from '../../services/translation.service';

@Component({
    selector: 'app-help-page',
    template: `
    <app-section>
      <app-claim-breadcrumb></app-claim-breadcrumb>
      @if (loaded) {
        <app-panel
          title="Helpful resources"
          [showTitle]="true"
          [headerLevel]="1"
          class="tw-w-full"
          [canExpand]="false"
          >
          @if (this.isMultiLanguageEnabled && (languagepreference != "en") && this.focus !== 'learningcenter')
          {
            <p >
                {{ 'Any documents, links, and videos in this section are authorized by your organization. Some items may not be available in your selected language and may only appear in English.' | translation: translationRequest}}
            </p>
            }
           
          <app-tab-group
            [tabGroupId]="'helpTabGroup'"
            [selectedIndex]="selectedIndex"
            animationDuration="0"
            class="app-pt1"
            sectionName="Help"
            (tabChange)="onTabChange($event)"
            >
            @if (showLearningCenter) {
              <app-tab
                class="app-pb2"
                label="Learning Center"
                featureName="LearningCenter"
                [template]="learningCenter"
                >
                <ng-template #learningCenter>
                  <app-learning-center [translationRequest]="translationRequest"></app-learning-center>
                </ng-template>
              </app-tab>
            }
            @if (links?.count) {
              <app-tab
                class="app-pb2"
                [label]="links?.description ? links?.description : 'Helpful Links'"
                featureName="HelpfulLinks"
                [template]="linkTemplate"
                >
                <ng-template #linkTemplate>
                  @if (links?.items) {
                    @for (lob of links?.items; track lob) {
                      <div class="app-pt1">
                        @if(lob?.isParentHasHeader === false){
                          <h2
                            class="app-header-2 app-pt3"
                            [ngClass]="lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'"
                            >
                            {{
                            (lob?.name === 'CS'
                            ? 'Client Specific'
                            : lob?.description | sentenceCase | translation: translationRequest) | sentenceCase | translation: translationRequest
                            }}
                          </h2>
                        }
                        @for (link of lob?.items; track link; let i = $index) {
                          @if(link.isHeader){
                            <h2
                              class="app-header-2 app-pt3"
                              [ngClass]="lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'"
                              >
                              {{
                              (link?.headerName | translation: translationRequest)
                              }}
                            </h2>
                          }
                          @if(!link.isHeader){
                            <div
                              class="app-pt2 app-pl2"
                              >
                              @if (link?.url && link?.url !== '#') {
                                <a
                                  class="link"
                                  tabindex="0"
                                  (click)="goToLink(link)"
                                  (keydown.enter)="goToLink(link)"
                                  target="_blank"
                                  >{{ link.displayUrlText }}</a
                                  >
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                    <div class="app-pt4"></div>
                  </ng-template>
                </app-tab>
              }
              @if (videos?.count) {
                <app-tab
                  class="app-pb2"
            [label]="
              videos?.description ? videos?.description : 'Helpful Videos'
            "
                  featureName="HelpfulVideos"
                  [template]="videoTemplate"
                  >
                  <ng-template #videoTemplate>
                    @if (videos?.items) {
                      @for (lob of videos?.items; track lob) {
                        <div class="app-pt1">
                          @if(lob?.isParentHasHeader === false){
                            <h2
                              class="app-header-2 app-pt3"
                              [ngClass]="lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'"
                              >
                              {{
                              lob?.name === 'CS'
                              ? ('Client Specific' | sentenceCase | translation: translationRequest)
                              : (lob?.description | sentenceCase | translation: translationRequest)
                              }}
                            </h2>
                          }
                          @for (link of lob?.items; track link) {
                            <div>
                              @if(link.isHeader){
                                <h2
                                  class="app-header-2 app-pt3"
                                  [ngClass]="lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'"
                                  >
                                  {{
                                  (link?.headerName | translation: translationRequest)
                                  }}
                                </h2>
                              }
                              @if(!link.isHeader){
                                @if (link?.url && link?.url !== '#') {
                                  <div class=" app-pt2 app-pl2">
                                    <a
                                      class="link"
                                      role="button"
                                      tabindex="0"
                          [attr.aria-label]="
                            ('Expand video ' | translation: translationRequest) + link?.displayUrlText
                          "
                          [attr.aria-expanded]="
                            currentVideoId === link?.id ? 'true' : 'false'
                          "
                                      [routerLink]=""
                                      (click)="playVideo(link)"
                                      (keydown)="playVideoCloseTabOut($event, link)"
                                      >{{ link?.displayUrlText }}</a
                                      >
                                    </div>
                                  }
                                  @if (currentVideoId === link?.id) {
                                    <iframe
                                      [src]="link?.url | safeUrl"
                                      allowfullscreen="true"
                                      height="338"
                                      webkitallowfullscreen="true"
                                      mozallowfullscreen="true"
                                      frameBorder="0"
                                      class="player app-pb3"
                                    ></iframe>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                      }
                      <div class="app-pt4"></div>
                    </ng-template>
                  </app-tab>
                }
                @if (documents?.count) {
                  <app-tab
                    class="app-pb2"
                    [label]="'Helpful Documents'"
                    featureName="DocsFaq"
                    [template]="documentTemplate"
                    >
                    <ng-template #documentTemplate>
                      @if (showDocument) {
                        <div class="app-pt2 app-pb2">
                          <a
                            [routerLink]=""
                            (click)="showDocument = false"
                            (keydown.enter)="showDocument = false"
                            >
                            {{ 'Helpful Documents' | translation: translationRequest }}
                          </a>
                          >{{ ' ' }}{{ 'View Document' | translation: translationRequest }}
                        </div>
                        <div class="app-header-2 app-pt2 app-pb2">
                          {{ currentDocument?.description }}
                        </div>
                        <ng-container
                          #pdfContainer
                          create
                          >
                        </ng-container>
                      }
                      @if (!showDocument) {
                        @if (documents?.items) {
                          @for (lob of documents?.items; track lob) {
                            <div class="app-pt1">
                              @if(lob?.isParentHasHeader === false){
                                <h2
                                  class="app-header-2 app-pt3"
                      [ngClass]="
                        lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'
                      "
                                  >
                                  {{
                                  (lob?.name === 'CS'
                                  ? 'Client Specific'
                                  : lob?.description) | sentenceCase | translation: translationRequest
                                  }}
                                </h2>
                              }
                              @for (link of lob?.items; track link; let i = $index) {
                                @if(link?.isHeader){
                                  <h2
                                    class="app-header-2 app-pt3"
                                    [ngClass]="lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'"
                                    >
                                    {{
                                    (link?.headerName | translation: translationRequest )
                                    }}
                                  </h2>
                                }
                                @if(!link.isHeader){
                                  <div
                                    class="app-pt2 app-pl2"
                                    >
                                    @if (link?.url && link?.url !== '#') {
                                      <a
                                        class="link"
                                        tabindex="0"
                                        (click)="downloadFile(link)"
                                        (keydown.enter)="downloadFile(link)"
                                        [routerLink]=""
                                        target="_blank"
                                        >{{ link?.displayUrlText }}</a
                                        >
                                      }
                                    </div>
                                  }
                                }
                              </div>
                            }
                            @for (lob of faqs?.items; track lob) {
                              <div class="app-pt1">
                                <h2
                                  class="app-header-2 app-pt3"
                      [ngClass]="
                        lob?.items.length > 0 ? 'tw-block' : 'tw-hidden'
                      "
                                  >
                                  {{
                                  (lob?.name === 'CS'
                                  ? 'Client Specific'
                                  : lob?.description) | sentenceCase | translation: translationRequest
                                  }}
                                </h2>
                                @for (link of lob?.items; track link; let i = $index) {
                                  <div
                                    class="app-pt2 app-pl2"
                                    >
                                    @if (link?.url && link?.url !== '#') {
                                      <a
                                        tabindex="0"
                                        class="link"
                                        (click)="downloadFile(link)"
                                        (keydown.enter)="downloadFile(link)"
                                        [routerLink]=""
                                        target="_blank"
                                        >{{ link?.displayUrlText }}</a
                                        >
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            }
                          }
                          <div class="app-pt4"></div>
                        </ng-template>
                      </app-tab>
                    }
                  </app-tab-group>
                </app-panel>
              }
            </app-section>
    `,
    styles: [
        `
      .player {
        width: 100%;
        height: 338px;
        max-width: 600px;
      }
    `,
    ],
    standalone: false
})

export class HelpPageComponent implements OnInit {
  help: HelpItem[] = [];
  links: HelpItem;
  allVideos: HelpItem;
  videos: HelpItem;
  documents: HelpItem;
  faqs: HelpItem;
  selectedIndex: number;
  showDocument = false;
  currentDocument: HelpItem;
  currentVideoId: string;
  lcType: string;
  loaded: boolean = false;
  lob: string;
  showLearningCenter: boolean;
  isMgr: boolean;
  mgrAction: UserActions | null;
  languagepreference: string;
  isMultiLanguageEnabled: boolean = false;
  focus: string = '';
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Helppage',
    subGroup: 'Helppage',
  });

  constructor(
    public helpfulLinkService: HelpfulLinkService,
    private route: ActivatedRoute,
    public session: Session,
    private utility: UtilityService,
    public config: ConfigurationService,
    public logService: LogService,
    private userRole: UserRoleService,
    private userAction: UserActionService,
    public translationService: TranslationService,
  ) {}

  loadTranslations(): void {
    this.translationService.getTranslation(this.translationRequest);
  }

  async ngOnInit() {    
    this.languagepreference = sessionStorage.getItem('languagepreference');    
    this.loadTranslations();
    this.lob = this.route.snapshot.queryParamMap.get('lob');
    const showLearningFlag = 'showLearningCenter';
    if (!sessionStorage.getItem(showLearningFlag)) {
        this.showLearningCenter =
              this.config.getConfigFeatureAccess('learningcenter');
        sessionStorage.setItem(
          showLearningFlag,
          this.showLearningCenter.toString()
        );
    } else {
      this.showLearningCenter =
        sessionStorage.getItem(showLearningFlag) === 'true';
    }
    !this.session.user ? await this.session.loadUser() : null;
    this.isMultiLanguageEnabled = await this.translationService.isMultiLanagueFeatureEnabled();
    
    this.isMgr = isManagement(this.session.user.role.toUpperCase());
    if (this.userRole.manager) {
      this.mgrAction = this.userAction.getAction();
    }

    this.loaded = false;
    await this.loadHelpfulLinks();

    this.links = this.help.find((item) => item.name === 'links');
    this.allVideos = this.help.find((item) => item.name === 'videos');

    if (this.lob && this.allVideos && this.allVideos.items) {
      this.videos = { ...this.allVideos };
    } else {
      this.videos = this.allVideos;
    }

    this.documents = this.help.find(
      (item) => item.name === 'documents' 
    );
   
    
    if (this.documents == undefined || this.documents?.items == undefined || this.documents.items?.length == 0) {
      this.documents = this.help.find(
        (item) => item.name === 'faqs'
      );
    }
    else {
    const faqslst = this.help.find((item) => item.name === 'faqs');
    if (faqslst != undefined && faqslst != null && faqslst.count > 0) {
        this.documents.items.push(...faqslst.items);
      }
    }    
  
    await this.setFocus();
    this.loaded = true;
  }

  async downloadFile(doc: HelpItem) {
    let role = 'HRM';
    if (this.userRole.manager && this.mgrAction == UserActions.ViewOwnEmpDb) {
      role = 'HRM';
    } else {
      role = this.session.user.role;
    }
    let extension = '';
    let blob = null;
    this.logService.LogFeature(undefined, 'FAQ', 'FAQ', doc.id);
    this.helpfulLinkService
      .downloadDocument(doc.id, role)
      .then((resp: HttpResponse<Blob>) => {
        extension = resp.headers.get('content-disposition');
        blob = resp.body;
        const ext = this.getExtension(extension);
        const type = this.utility.createFileType(ext);
        const newBlob = new Blob([blob], { type: type });
        this.utility.downloadFile(newBlob, doc.displayUrlText);
      });
  }

  goToLink(link: any) {
    if (link.displayUrlText.toLowerCase() === 'medline plus') {
      this.logService.LogFeature(
        undefined,
        'Medline Plus',
        'Helpful Links',
        link.id
      );
    } else {
      this.logService.LogFeature(
        undefined,
        'Helpful Link',
        'Helpful Link',
        link.id
      );
    }
    window.open(link.url, '_blank');
  }

  playVideo(link: any) {
    this.currentVideoId = link?.id;
    this.logService.LogFeature(
      undefined,
      'Helpful Video',
      'Helpful Video',
      link.id
    );
  }

  playVideoCloseTabOut(event: any, link: any) {
    if (event.keyCode == 13) {
      this.currentVideoId = link?.id;
      this.logService.LogFeature(
        undefined,
        'Helpful Video',
        'Helpful Video',
        link.id
      );
    }
  }
  private readonly featureToFocus: Record<string, string> = {
    LearningCenter: 'learningcenter',
    HelpfulLinks: 'links',
    HelpfulVideos: 'videos',
    DocsFaq: 'documents',
  };

  onTabChange(tab: any) {
    this.resetVideo();
    if (tab?.featureName) {
      this.focus = this.featureToFocus[tab.featureName] ?? '';
    }
  }

  resetVideo() {
    this.currentVideoId ? (this.currentVideoId = null) : null;
  }

  private async setFocus() {
    this.focus = this.route.snapshot.queryParamMap.get('focus');
    const hasLC = await this.config.getConfigFeatureAccess('learningcenter');
    if (hasLC) {
      if (this.focus === 'learningcenter') {
        this.selectedIndex = 0;
      } else if (this.focus === 'links') {
        this.selectedIndex = 1;
      } else if (this.focus === 'videos') {
        this.selectedIndex = 2;
      } else if (this.focus === 'documents') {
        this.selectedIndex = 3;
      } else {
        this.selectedIndex = 0;
      }
    } else {
      if (this.focus === 'links') {
        this.selectedIndex = 0;
      } else if (this.focus === 'videos') {
        this.selectedIndex = 1;
      } else if (this.focus === 'documents') {
        this.selectedIndex = 2;
      } else {
        this.selectedIndex = 0;
      }
    }
  }

  private getExtension(type: string): string {
    /* This might need to change if somehow filename is not the [1] element in header */
    const file = type
      .split(';')[1]
      .split('filename')[1]
      .split('=')[1]
      .trim()
      .replace(/\"/g, '');
    return file.split('.').pop();
  }

  private async loadHelpfulLinks() {

    this.lcType = this.getLcType(this.lob);
    this.help = [];

    this.help = (await this.helpfulLinkService.getHelpfulLinks(
      this.lcType
    )) as HelpItem[];
  }

  getLcType(lob: string) {
    const lobTypes = ['WC', 'AU', 'GL', 'PR', 'PL']; // these have CLAIMANT and CONTROLLER type in setup app
    const mgrAction = this.userAction.getAction();
    if (lobTypes.includes(lob)) {
      if (
        (this.isMgr &&
          (mgrAction == UserActions.ViewOwnMgrDb ||
            mgrAction == UserActions.MgrViewEmpClaim ||
            mgrAction == UserActions.MgrViewEmpDb)) ||
        this.userRole.controller
      ) {
        return 'CONTROLLER';
      } else {
        return 'HRM';
      }
    } else {
      if (
        (this.isMgr &&
          (mgrAction == UserActions.ViewOwnMgrDb ||
            mgrAction == UserActions.MgrViewEmpClaim ||
            mgrAction == UserActions.MgrViewEmpDb ||
            mgrAction == UserActions.ManagerSummaryView)) ||
        this.userRole.controller
      ) {
        return this.session.user.role.toUpperCase();
      } else {
        return 'HRM';
      }
    }
  }
}

export class HelpItem {
  id?: string;
  name: string;
  description: string;
  items?: HelpItem[] = [];
  count?: number = 0;
  url?: string;
  type?: 'link' | 'video' | 'document';
  local?: boolean = false;
  activationDate?: Date;
  displayUrlText: string;
  headerName : string;
  isHeader? :boolean = false;
  isParentHasHeader? : boolean = false;
}
